import GlassCard from '@/components/GlassCard';
import useApi from '@/hooks/useApi';
import React, { useEffect, useRef, useState } from 'react';
import OnboardingDismissButton from './OnboardingDismissButton';
import OnboardingTabBar from './OnboardingTabBar';
import OnboardingTabPanel from './OnboardingTabPanel';

interface OnboardingTab {
    id: number;
    title: string;
    description?: string | null;
    video_url?: string | null;
    vimeo_url?: string | null;
}

export interface OnboardingData {
    id: number;
    grace_days: number;
    tabs: OnboardingTab[];
    has_visibility_record: boolean;
    is_visible: boolean;
}

interface Props {
    onboarding: OnboardingData;
    onDismiss: () => void;
}

const OnboardingSection: React.FC<Props> = ({ onboarding, onDismiss }) => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const api = useApi();
    const recordedRef = useRef(false);

    useEffect(() => {
        if (!onboarding.has_visibility_record && !recordedRef.current) {
            recordedRef.current = true;
            api.post('/onboarding/record-view/');
        }
    }, [onboarding.has_visibility_record]);

    if (onboarding.tabs.length === 0) {
        return null;
    }

    const handleDismiss = () => {
        onDismiss();
    };

    const activeTab = onboarding.tabs[activeTabIndex];

    return (
        <GlassCard className="p-6 shadow-lg">
            <div className="mb-4 flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
                <div className="min-w-0 flex-1">
                    <OnboardingTabBar
                        tabs={onboarding.tabs}
                        activeIndex={activeTabIndex}
                        onTabChange={setActiveTabIndex}
                    />
                </div>
                <div className="flex justify-end xl:ml-4 xl:flex-shrink-0">
                    <OnboardingDismissButton onDismiss={handleDismiss} />
                </div>
            </div>
            <OnboardingTabPanel tab={activeTab} />
        </GlassCard>
    );
};

export default OnboardingSection;
